import {Component, Input, OnInit} from '@angular/core';
import {StatusEventType} from '@constants/machine/status-event-signal/status-event-type.enum';
import {StatusEventPageEventDisplayDetails} from '@models/pages/status-event-page/status-event-page-event-display-details';
import {TranslationService} from '@services/translation/translation.service';
import {StatusEventPageDataService} from '@services/pages/status-event-page/data/status-event-page-data.service';
import {StatusEventTypeDescription} from '@constants/machine/status-event-signal/status-event-type-description';

@Component({
    selector: 'scitis-status-item',
    templateUrl: './status-item.component.html',
    styleUrls: ['./status-item.component.scss'],
    standalone: false
})
export class StatusItemComponent implements OnInit {

  @Input()
  public statusEventDetails: StatusEventPageEventDisplayDetails[] = [];

  private language: string = '';

  constructor(
      private translationService: TranslationService,
      private statusEventPageDataService: StatusEventPageDataService) {
    this.language = this.translationService.getActiveLanguage();
  }

  public getWidgetItemClass(statusEvent: StatusEventPageEventDisplayDetails) {
    switch (statusEvent.type) {
      case StatusEventType.FAILURE:
        return 'widget-row-' + StatusEventTypeDescription.FAILURE;
      case StatusEventType.WARNING:
        return 'widget-row-' + StatusEventTypeDescription.WARNING;
      case StatusEventType.INFO:
        return 'widget-row-' + StatusEventTypeDescription.INFO;
      case StatusEventType.DEBUG:
        return 'widget-row-' + StatusEventTypeDescription.DEBUG;
      case StatusEventType.INHIBIT:
        return 'widget-row-' + StatusEventTypeDescription.INHIBIT;
      case StatusEventType.UNSUPPORTED:
        return 'widget-row-' + StatusEventTypeDescription.UNSUPPORTED;
      case StatusEventType.UNDEFINED:
        return 'widget-row-' + StatusEventTypeDescription.UNDEFINED;
    }
  }

  ngOnInit(): void {
    this.translationService.getLanguageChangeEventSubject().subscribe((language: string) => {
      this.language = language;
    });
  }

  public getType(statusEvent: StatusEventPageEventDisplayDetails): string {
    return statusEvent.type;
  }

  public getClass(statusEvent: StatusEventPageEventDisplayDetails): string {
    switch (statusEvent.type) {
      case StatusEventType.FAILURE:
        return 'fa-triangle-exclamation';
      case StatusEventType.WARNING:
        return 'fa-circle-exclamation';
      case StatusEventType.INFO:
        return 'fa-circle-info';
      case StatusEventType.INHIBIT:
        return 'fa-ban';
      case StatusEventType.DEBUG:
        return 'fa-gear';
      default :
        return 'fa-circle-question';
    }
  }

  public getDescription(statusEvent: StatusEventPageEventDisplayDetails): string {
    return `${statusEvent.code} ${this.statusEventPageDataService.getLocalizedDescriptionOrDefault(this.language, statusEvent)}`;
  }

}
